import * as React from 'react';
import { ButtonSecondary, CloseButton, ButtonPrimary, ElementLoader } from 'ui';
import { HotKeys } from "ui/common/hotkeys";
import { keyCodeTypes } from "ui/common/key-code-types";
import styles from './regenerate-aggregated-modal.scss';
import { FaInfo } from 'react-icons/fa';

export interface RegenerateAggregatedModalProps {
  translation?: any;
  onClose: () => void;
  fetchingRegenerateAggregated: boolean;
  executeRegenerateAggregatedEnv: () => void;
}

export class RegenerateAggregatedEnvModal extends React.PureComponent<RegenerateAggregatedModalProps, any> {
  public render() {
    const { fetchingRegenerateAggregated, translation } = this.props;

    const keyMap = {
      onClose: [keyCodeTypes.Esc]
    };

    const handlers = {
      onClose: () => this.props.onClose()
    };

    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className={`modal ${styles.regenerateAggregatedModal}`}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>{translation.regenerate_aggregated_environmental_title}</h5>
                <CloseButton data-dismiss="modal" onClick={this.props.onClose} />
              </div>
              <div className={`modal-body ${styles.regenerateAggregatedModalBody}`}>
                <div className={styles.disclaimerPanel}>
                  <FaInfo /> {translation.regenerate_aggregated_environmental_info}
                </div>
                {fetchingRegenerateAggregated ? <div className={styles.loader}>
                  {<ElementLoader />}
                </div> : translation.regenerate_aggregated_environmental_description}
              </div>
              <div className={`modal-footer ${styles.regenerateAggregatedModalFooter}`}>
                <ButtonSecondary dataDismiss="modal" onClick={this.props.onClose} disabled={fetchingRegenerateAggregated}>
                  {translation.regenerate_aggregated_cancel}
                </ButtonSecondary>
                <ButtonPrimary onClick={this.props.executeRegenerateAggregatedEnv} disabled={fetchingRegenerateAggregated}>
                  {translation.regenerate_aggregated_submit_button}
                </ButtonPrimary>
              </div>
            </div>
          </div>
          <div className="modal-background" onClick={this.props.onClose} />
        </div>
      </HotKeys>
    );
  }
}
